import type { StyleRule } from '@archipro-design/aria';
import { pxToRem } from '@archipro-design/aria';
import { labelClassName } from '@archipro-design/aria';
import { buttonClassName } from '@archipro-design/aria';
import { captionClassName } from '@archipro-design/aria';
import { pxArrayToRem } from '@archipro-design/aria';
import { svgIconClassName } from '@archipro-design/icons';

export const Details: StyleRule = () => ({
    padding: pxArrayToRem([7, 18, 0, 18]),
    marginBottom: pxToRem(80),
    ['& .' + captionClassName]: {
        lineHeight: '150%',
        minHeight: pxToRem(24),
    },
    '& *': {
        outlineOffset: '0',
    },
});

export const ContentGrid: StyleRule = ({ theme }) => ({
    columnGap: theme.siteVariables.spaces['space-6'],
    borderBottom: `1px solid ${theme.siteVariables.colors.grey['125']}`,
    alignItems: 'center',
    '& > *': {
        padding: pxArrayToRem([13, 0, 12, 0]),
    },
});

export const ContentRightGrid: StyleRule = {
    textAlign: 'right',
};

export const ShowMoreIcon: StyleRule = ({ theme }) => ({
    ['&.' + svgIconClassName]: {
        '& svg': {
            marginTop: pxToRem(2),
            width: pxToRem(10),
            height: pxToRem(10),
            '& path': {
                fill: theme.siteVariables.colors.white['000'],
            },
        },
    },
});

export const ShowLessIcon: StyleRule = ({ theme }) => ({
    ['&.' + svgIconClassName]: {
        width: pxToRem(16),
        height: pxToRem(16),
        marginLeft: pxToRem(-3),
        marginTop: pxToRem(-1),
        '& svg': {
            '& path:nth-child(2)': {
                fill: theme.siteVariables.colors.white['000'],
            },
        },
    },
});

export const DownloadButton: StyleRule = () => ({
    ['&.' + buttonClassName]: {
        width: '100%',
        justifyContent: 'space-between',
        alignItems: 'center',
        [`& .${labelClassName}`]: {
            textAlign: 'left',
        },
        [`& .${svgIconClassName}`]: {
            width: pxToRem(20),
            height: pxToRem(20),
            marginLeft: pxToRem(4),
        },
    },
});

export const ToggleButton: StyleRule = ({ theme }) => ({
    marginTop: theme.siteVariables.spaces['space-12'],
    ['& .' + labelClassName]: {
        ...theme.siteVariables.textStyles.Text.Medium65,
        textDecoration: 'underline',
        textUnderlineOffset: pxToRem(1),
        textDecorationThickness: '1px',
    },
});
